import { Component } from '@angular/core';
import { ColmecTirePolicy } from '../../../services/colmec-tire-policy.service';
import { ListItemRendererComponent } from 'gung-list';

@Component({
    selector: 'colmec-tire-policy-table-view',
    templateUrl: './colmec-tire-policy-table-view.component.html',
    styleUrls: ['./colmec-tire-policy-table-view.component.scss'],
    standalone: false
})
export class ColmecTirePolicyTableViewComponent extends ListItemRendererComponent<ColmecTirePolicy[]> { }
